var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIconGrey1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 18.2016C5.2783 18.2016 1.19287 14.1188 1.19287 9.10036C1.19287 4.08192 5.2783 -0.000488281 10.3 -0.000488281C15.3217 -0.000488281 19.4072 4.08228 19.4072 9.10072C19.4072 14.1192 15.3217 18.2019 10.3 18.2019V18.2016ZM10.3 3.78701C7.36821 3.78701 4.98284 6.17083 4.98284 9.10072C4.98284 12.0306 7.36821 14.4144 10.3 14.4144C13.2318 14.4144 15.6172 12.0306 15.6172 9.10072C15.6172 6.17083 13.2318 3.78701 10.3 3.78701Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2393 25.0001C6.55527 25.0001 3.08607 23.5722 0.470703 20.9795L3.1396 18.2907C5.04037 20.175 7.56171 21.2126 10.2393 21.2126C12.9169 21.2126 15.5163 20.1436 17.4272 18.2021L20.129 20.8581C17.5003 23.5289 13.9877 25.0001 10.2393 25.0001Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 11.377C11.4899 11.377 12.4615 10.3967 12.4615 9.18752C12.4615 7.97831 11.4899 6.99805 10.2913 6.99805C9.09272 6.99805 8.12109 7.97831 8.12109 9.18752C8.12109 10.3967 9.09272 11.377 10.2913 11.377Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIconGrey1);
export default __webpack_public_path__ + "static/media/discover-icon-grey1.a400d60464d7333cb42eced20b83bf2d.svg";
export { ForwardRef as ReactComponent };